import { Box, CardMedia, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { TextAppHistoryItem, TextSuiteApps } from "../../../../Helper";
import {
  convertUtcToLocalDateTime,
  formatDateAndHour,
} from "../../../../store/one-query/useMethodHelper";
import { RemoveIcon } from "../../../../Custom-imeges/RemoveIcon";
import { useNavigate } from "react-router-dom";
import { DeleteAllHistoryModal } from "../../../../Layouts/SuiteHistoryLayout/Shared/DeleteAllHistoryModal";
import { returnAppIcon } from "../../../../Layouts/SuiteHistoryLayout/View/SuiteHistoryView";

const sharedTextAppInputStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  lineHeight: "25px",
};

interface TextSuiteHistoryItemProps {
  textAppItem: TextAppHistoryItem;
  DeleteTextItem: (itemId: string) => void;
  isDeleteTextItemLoading: boolean;
  isTextItemDeleted: boolean;
}

export const TextSuiteHistoryItem = ({
  textAppItem,
  DeleteTextItem,
  isDeleteTextItemLoading,
  isTextItemDeleted
}: TextSuiteHistoryItemProps) => {
  const navigate = useNavigate();
  const [canShowDeleteAllHistory, setCanShowDeleteAllHistory] = useState(false);
  const [historyItemId, setHistoryItemId] = useState("");

  const handleShowDeleteItemModal = (itemId: string) => {
    setHistoryItemId(itemId);
    setCanShowDeleteAllHistory(true);
  };

  const handleDeleteTextItem = () => {
    DeleteTextItem(historyItemId);
  };

  const handleActiveHistoryItem = (item: TextAppHistoryItem) => {
    navigate("/suites/text-suite", {
      state: { activeAppId: item.id, activeAppType: item.appType },
    });
  };

  const hasInputImage = (appType: string) =>
    appType === TextSuiteApps.TextExtraction ||
    appType === TextSuiteApps.ImageToPrompt;

  useEffect(() => {
    if (isTextItemDeleted) {
      setCanShowDeleteAllHistory(false);
    }
  }, [isTextItemDeleted]);
  
  return (
    <>
      <Box
        className="text-suite-history-item"
        onClick={() => handleActiveHistoryItem(textAppItem)}
        sx={{
          height: "120px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          className="delete-text-item"
          onClick={(e) => {
            e.stopPropagation();
            handleShowDeleteItemModal(textAppItem.id);
          }}
        >
          <RemoveIcon className="custom-icon" />
        </Box>
        {hasInputImage(textAppItem.appType) ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <CardMedia
              component={"img"}
              image={textAppItem.input}
              alt={"input image"}
              sx={{
                width: "55px",
                height: "55px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />

            <Typography
              className="text-item-input"
              sx={{
                ...sharedTextAppInputStyle,
                width: "92%",
              }}
            >
              {textAppItem.output}
            </Typography>
          </Box>
        ) : (
          <Box className="text-item-input" sx={sharedTextAppInputStyle}>
            {textAppItem.input}
          </Box>
        )}
        <Box className="text-item-details">
          <Box className="suite-app-name">
            <Box className="app-name-icn">
              {returnAppIcon(textAppItem.appType)}
            </Box>
            <Box className="app-name-title">{textAppItem.appType}</Box>
          </Box>
          <Box className="suite-app-date">
            {convertUtcToLocalDateTime(textAppItem.createdAt)}
          </Box>
        </Box>
      </Box>
      {canShowDeleteAllHistory && (
        <DeleteAllHistoryModal
          canShow={canShowDeleteAllHistory}
          handleClose={() => setCanShowDeleteAllHistory(false)}
          handleDeleteAllHistory={handleDeleteTextItem}
          isDeleteLoading={isDeleteTextItemLoading}
          message="Are you sure to clear this history item?"
        />
      )}
    </>
  );
};
